<template>
  <div class="view-list">
      <div class="view-title">浏览记录&nbsp;<van-icon name="question" color= '#bfbfbf' @click="showTips"/></div>
      <van-search
      v-model="keyword"
      @input="handleSearch()"
      @search="handleSearch()"
      shape="round"
      
      placeholder="请输入ERP搜索"
      />
      <div class="list-wrap">
      <van-pull-refresh
        v-if="list.length || loading"
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in list"
            :key="item.id"
            class="record-item"
          >
          <van-image
            @click="handlePersonal(item.id)"
            round
            width="1rem"
            height="1rem"
            :src="item.avatar"
          />
          <div class="record-content">
            <div>
              <div @click="handlePersonal(item.id)">{{item.erpName || item.erp}}</div>
              <span>最近浏览：&nbsp;{{item.createTime}}</span>
            </div>
            <span>{{item.dept}}</span>
          </div>
          </div>
        </van-list>
      </van-pull-refresh>
      </div>
  </div>
</template>
<script>
import api from '@/api';
import { throttle } from '@/utils/lib';

export default {
  props: ['postId', 'showViewRecords'],
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageParams: {
        page: 1,
        pageSize: 30
      },
      total: 0
    }
  },
  watch: {
    showViewRecords: {
      immediate: true,
      handler(_showViewRecords) {
        if (_showViewRecords) {
          this.fetchList();
        } else {
          this.finished = false;
          this.keyword = '';
          this.refreshing = false;
          this.pageParams.page = 1;
          this.list = [];
          this.total = 0;
        }
      },
    }
  },
  methods: {
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    },
    showTips() {
      this.$toast({
        message: '每人每天访问文章详情页1次，总浏览人次可+1。如文章发布外网，总浏览人次包括文章在神灯内部和外网阅读量总和，仅可展示内网读者明细。(仅展示近3个月的访问记录)',
        closeOnClick: true,
        closeOnClickOverlay: true,
        duration: 0,
        overlay: true,
        overlayStyle: {
          backgroundColor: 'rgba(0,0,0,0.1)'
        }
      })
    },
    onRefresh() {
      this.finished = false
      this.pageParams.page = 1 
      this.fetchList()
    },
    onLoad() {
      this.pageParams.page++
      this.fetchList()
    },
    handleSearch: throttle(function() {
      this.finished = false
      this.pageParams.page = 1
      this.list = []
      this.fetchList()
    }, 1000),
    async fetchList() {
      this.loading = true;
      const {code, data, pageCount, totalCount } = await api.getPostViewRecord({
        ...this.pageParams,
        postId: this.postId,
        erp: this.keyword,
      })
      this.loading = false;
      if (this.refreshing) {
        this.refreshing = false
      }
      if (code === 200) {
        if (this.pageParams.page > 1) {
          this.list = this.list.concat(data?.map((item) => ({
            ...item,
            dept: item?.department?.split('-')?.slice(1, 4)?.join('-')
          })))
        } else {
          this.list = data?.map((item) => ({
            ...item,
            dept: item?.department?.split('-')?.slice(1, 4)?.join('-')
          }))
        }
        this.total = totalCount;
        if (this.pageParams.page >= pageCount) {
          this.finished = true
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.view-title {
  font-size: 15px;
  font-weight: bold;
  padding: 8px 12px;
  border-bottom: 1px solid #fbfbfb;
}
.view-list {
  display: flex;
  flex-direction: column;
  text-align: left;
  height: 100%;
  overflow: hidden;
  /deep/ .van-search {
    flex-shrink: 0;
  }
.list-wrap {
    flex: 1;
    overflow: auto;
    padding: 0px 16px 12px 16px;
  }
  .record-item {
    display: flex;
    align-items: center;
    padding: 8px 0 ;
    .record-content {
      flex: 1;
      padding-left: 12px;
      & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > div {
          font-size: 14px;
          font-weight: bold;
        }
      }
      span {
          color: #bfbfbf;
          font-size: 12px;
          transform: scale(0.9);
        }
    }
  }
}
.tips {
  text-align: right;
  padding: 0 12px 8px 0;
  font-size: 13px;
  /deep/ .van-icon-question {
    font-size: 15px;
  }
}
</style>